import { Outlet } from "react-router-dom";

export default function AuthLayout() {
  return (
    <div className="flex items-center justify-center min-h-screen bg-white px-4">
      <div className="relative w-full max-w-md space-y-6 text-center">
        {/* Shared illustration / logo */}
        <img
          src="/Klinifai_Logo_Vertical_Transparent.svg"
          alt="Klinifai Logo"
          className="mx-auto w-52 h-auto"
        />

        {/* This is where Login / ForgotPassword / ResetPassword will render */}
        <div className="p-4">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
